export enum SettingsRoutes {
  DEFAULT = '/settings',
  OVERVIEW = '/settings/overview',
  MY_ACCOUNT = '/settings/my-account',
  LOGIN_SECURITY = '/settings/login-security',
  USERS = '/settings/users',
  ORGANIZATIONS = '/settings/organizations',
  APPS = '/settings/apps',
  AUDIT = '/settings/audit',
  TAGS_NEW_FLOW = '/settings/tags-new-flow',
}

export enum MainRoutes {
  SETTINGS = '/settings',
  REPORTS = '/reports',
  API = '/api',
  GROUPS = '/groups',
  DEVICE_BLOCKS = '/device-blocks',
  TAGS_MANAGEMENT = '/tags-management',
  DEVELOPER = '/developer',
  DEVELOPER_SDK = '/developer/sdk',
  DEVELOPER_BATCH = '/developer/batch',
  DEVELOPER_BATCH_CREATE = '/developer/batch/create',
  DEVELOPER_CREDENTIALS = '/developer/credentials',
}
